export default __webpack_public_path__ + "static/media/reserva_cancelar.ac41a762.jpg";